import { SecondaryLayout, TabGroup } from '../../share/Components'
import { ReactElement } from 'react'
// import Timesheet from '../Timesheet/Timesheet'
import SettingIHIOInsurance from './SettingIHIOInsurance'
import { TabInterface } from '../../Interfaces/TabInterface'
import SettingTaminInsurace from './SettingTaminInsurance'

const Setting = () => {
  const listTab: Array<TabInterface> = [
    {
      title: 'تنظیمات بیمه تامین',
      icon: 'rayteb-tamin',
      index: true,
      className: {
        iconClass: 'text-3xl ',
        className: 'px-10 pb-1',
        titleClass: 'text-xs',
      },
      element: <SettingTaminInsurace />,
    },
    {
      title: 'تنظیمات بیمه سلامت',
      icon: 'rayteb-ihio',
      index: false,
      className: {
        iconClass: 'text-3xl ',
        className: 'px-10 pb-1',
        titleClass: 'text-xs',
      },
      element: <SettingIHIOInsurance />,
    },
  ]
  return (
    <>
      <TabGroup items={listTab} />
    </>
  )
}

export default Setting

Setting.Layout = ({ children }): ReactElement => {
  return (
    <>
      <SecondaryLayout title={'تنظیمات'}>{children}</SecondaryLayout>
    </>
  )
}
